/* so-stock-state — the store's ONE stock vocabulary (roadmap F2). Four states only:
     in    tracked qty > lowAt, or untracked  "In stock · ships today"
     low   1..lowAt, deny                     "Only 3 left · ships today"
           1..lowAt, continue                 "3 in stock · ships today · more on pre-order" (card: "In stock")
     pre   continue-selling and qty <= 0      "Pre-order · ships around Mon 5 – Mon 12 Oct" (compact "5 – 12 Oct")
     gone  deny and qty <= 0                  "Out of stock · get notified" / "No longer stocked" (never green)
   Quantity-aware PDP line (Amendment Q1): when stepper + cart > stock → overState() → "Only 3 left · you can add 1" etc.
   P0-12: with some of it in the cart (and no over state) → "In stock · 5 in your cart · ships Tuesday" (clause = IN_CART).
   lowAt = theme setting inventory_threshold_low (9). Dates from SO.dates (SAST, 7 AM cut-off, holidays);
   "today" or the weekday, never "tomorrow". Liquid twin: snippets/so-stock-state.liquid (server-side state +
   date-less fallback). Loaded `defer` in <head> after so-dates.js. */
(function (root, factory) {
  var node = typeof window === 'undefined' && typeof module === 'object' && module.exports;
  var getDates = node ? (function (d) { return function () { return d; }; })(require('./so-dates.js'))
                      : function () { return (root.SO && root.SO.dates) || null; };
  var api = factory(getDates);
  if (node) module.exports = api;
  else { root.SO = root.SO || {}; root.SO.stock = api; api._define(root); }
})(typeof self !== 'undefined' ? self : this, function (dates) {
  function cfgOf(opts) {
    var D = dates();
    return (opts && opts.cfg) || (D && D.readConfig ? D.readConfig() : null) || { lowAt: 9 };
  }
  function lowAt(cfg) { var c = cfg || cfgOf(); return Number(c && c.lowAt) > 0 ? Number(c.lowAt) : 9; }
  // P0-12 cart clause, inserted after the F2 head on the PDP line. ONE place for the words (wording confirmed
  // by Charl, plan DL11): "In stock · 5 in your cart · ships Tuesday" / "Only 3 left · 1 in your cart · …".
  var IN_CART = ' · {n} in your cart';
  function num(v) { if (v == null || v === '') return null; var x = Number(v); return isFinite(x) ? x : null; }

  // v = {tracked?, policy?|inventory_policy?, qty?|inventory_quantity?, dead?} → {state, n, q, policy, dead}
  function classify(v, low) {
    v = v || {};
    var policy = v.policy || v.inventory_policy || null;
    if (policy !== 'continue' && policy !== 'deny') policy = null;
    var tracked = v.tracked !== false && v.tracked !== 'false';
    var q = tracked ? num(v.qty != null ? v.qty : v.inventory_quantity) : null;
    if (tracked && q == null) q = 0;
    var r = { state: 'gone', n: null, q: q, policy: policy, dead: false };
    if (v.dead) { r.dead = true; return r; }
    if (!tracked) { r.state = 'in'; return r; }
    var L = Number(low) > 0 ? Number(low) : lowAt();
    if (q > L) r.state = 'in';
    else if (q > 0) { r.state = 'low'; r.n = q; }
    else if (policy === 'continue') r.state = 'pre';
    return r;
  }

  // compact → "ships around 5 – 12 Oct" (rows, pills, FBT, cart gate); else "ships around Mon 5 – Mon 12 Oct".
  // bare → the same text with the leading "ships " dropped ("around 5 – 12 Oct" / "in 5–10 business days"),
  // for surfaces that already supply their own verb ("Whole order ships together, {bare}.").
  function shipText(state, cfg, now, compact, bare) {
    var D = dates();
    cfg = cfg || cfgOf(); now = now != null ? now : Date.now();
    if (!D || !cfg) return '';
    if (state === 'in' || state === 'low') {
      var d = D.dispatchDay(now, cfg);
      if (!D.holidaysCover(d, cfg)) return '';
      var w0 = D.dayWord(d, D.todayOf(now), true); // "ships Tuesday" — full day name (Charl)
      return bare ? w0 : 'ships ' + w0;
    }
    if (state === 'pre') {
      var w = D.preorderWindow(cfg, now);
      if (w) { var r = (compact ? D.fmtRangeShort : D.fmtRange)(w.from, w.to); return (bare ? 'around ' : 'ships around ') + r; }
      if (D.leadDays(cfg.preorderDays != null ? cfg.preorderDays : cfg.preorderLeadTime) && cfg.preorderLeadTime) {
        var lead = String(cfg.preorderLeadTime).trim();
        return (bare ? 'in ' : 'ships in ') + lead;
      }
      return '';
    }
    return '';
  }

  // Amendment Q1 / R10: the ONE decision for "the shopper wants more than we have".
  // null, or {kind:'split'|'cap'|'all', avail} where avail = units still addable from stock (q − inCart, ≥ 0).
  function overState(c, want, inCart) {
    want = Number(want) || 0;
    if (!c || c.dead || !(want > 0) || c.q == null || !(c.q > 0)) return null;
    var inC = Math.max(0, Number(inCart) || 0), total = inC + want;
    if (total <= c.q) return null;
    var avail = Math.max(0, c.q - inC);
    if (c.policy === 'continue') return { kind: 'split', avail: avail };
    return { kind: inC >= c.q ? 'all' : 'cap', avail: avail };
  }
  // The stepper cap: only for sell-to-zero items with stock. null = no cap (pre-order, untracked, continue, sold out).
  function maxAddable(c, inCart) {
    return c && !c.dead && c.q != null && c.q > 0 && c.policy === 'deny' ? Math.max(0, c.q - Math.max(0, Number(inCart) || 0)) : null;
  }

  function label(c, ctx, opts) {
    opts = opts || {};
    ctx = ctx || 'pdp';
    var cfg = cfgOf(opts), now = opts.now != null ? opts.now : Date.now();
    var packs = opts.unit === 'packs';
    // Count noun: "1 pack" / "3 packs" for pack products (ZYN), nothing otherwise ("Only 3 left").
    function u(n) { return packs ? (Number(n) === 1 ? ' pack' : ' packs') : ''; }
    // "the last pack" / "the last 3 packs" / "the last one" / "the last 3".
    function lastOf(q) { return q === 1 ? (packs ? 'the last pack' : 'the last one') : 'the last ' + q + u(q); }
    var cont = c.policy === 'continue';
    // Every tracked variant says how many are in stock, above the low threshold too (Charl 2026-10-12):
    // "34 in stock" / "14 packs in stock". Untracked items and bundles (no count) stay "In stock".
    var inHead = c.q > 0 ? c.q + u(c.q) + ' in stock' : 'In stock';
    if (ctx === 'pdp') {
      var ov = overState(c, opts.want, opts.inCart);
      if (ov) {
        var inC = Math.max(0, Number(opts.inCart) || 0), total = inC + Number(opts.want);
        if (ov.kind === 'split') {
          // Charl 2026-09-28: when the cart already holds the stock, say so plainly.
          if (inC >= c.q) {
            var pb = shipText('pre', cfg, now, false, true);
            return 'Your cart has ' + lastOf(c.q) + ' · any more will be pre-order' + (pb ? ', shipping ' + pb : '');
          }
          var ps = shipText('pre', cfg, now);
          return 'Only ' + c.q + u(c.q) + ' in stock' + (inC > 0 ? ' (' + inC + ' in your cart)' : '') + ' · ' +
            (total - c.q) + ' will be pre-order' + (ps ? ', so this order ' + ps : '');
        }
        if (ov.kind === 'all') return 'Your cart has ' + lastOf(c.q);
        return 'Only ' + c.q + u(c.q) + ' left · ' + (inC > 0 ? 'you can add ' + ov.avail : "that's all we have");
      }
      // P0-12: say what the cart already holds. F2's heads unchanged (no stock number above the low
      // threshold); a full cart is the over branch above ("Your cart has the last …").
      var had = Math.max(0, Number(opts.inCart) || 0);
      if (had > 0 && !c.dead && c.state !== 'gone') {
        var mine = IN_CART.replace('{n}', had);
        if (c.state === 'pre') { var pw = shipText('pre', cfg, now, !!opts.compact); return 'Pre-order' + partOf(opts) + mine + (pw ? ' · ' + pw : ''); }
        var hd = c.state === 'in' ? inHead : cont ? c.n + u(c.n) + ' in stock' : 'Only ' + c.n + u(c.n) + ' left';
        var sw = shipText(c.state, cfg, now);
        return hd + mine + (sw ? ' · ' + sw : '') + (c.state === 'low' && cont ? ' · more on pre-order' : '');
      }
    }
    if (c.state === 'in' || c.state === 'low') {
      // Cards: availability only when it's news — "Only N left" on sell-out items; the flavour line
      // (so-flavour-count) carries "24 flavours · 18 in stock" for multi-flavour products (Charl 2026-09-28).
      if (ctx === 'card') return c.state === 'low' && !cont ? 'Only ' + c.n + u(c.n) + ' left' : '';
      var head = c.state === 'in' ? inHead : cont ? c.n + u(c.n) + ' in stock' : 'Only ' + c.n + u(c.n) + ' left';
      var more = c.state === 'low' && cont ? ' · more on pre-order' : '';
      if (ctx !== 'pdp') return head + more;
      var s = shipText(c.state, cfg, now);
      return head + (s ? ' · ' + s : '') + more;
    }
    if (c.state === 'pre') {
      if (ctx === 'card') return '';
      var p = shipText('pre', cfg, now, ctx === 'row' || !!opts.compact);
      return 'Pre-order' + (ctx === 'pdp' ? partOf(opts) : '') + (p ? ' · ' + p : '');
    }
    if (ctx === 'card') return '';
    if (c.dead) return 'No longer stocked';
    var gp = ctx === 'pdp' ? partOf(opts) : '';
    return opts.notify ? 'Out of stock' + gp + ' · get notified' : 'Out of stock' + gp;
  }
  // Bundles name the part that makes the bundle a pre-order / sold out (Charl 2026-10-14):
  // "Pre-order: #7 South Pole · ships around …". Only so-preorder-pdp sets it, only for bundles.
  function partOf(opts) { return opts && opts.part ? ': ' + opts.part : ''; }
  function tone(state) { return state === 'in' || state === 'low' || state === 'pre' ? state : 'gone'; }
  // The tone a painted line actually gets: over-quantity → low (amber); a card's continue-low reads "In stock" → in.
  function toneOf(c, ctx, opts) {
    if (ctx === 'pdp' && overState(c, opts && opts.want, opts && opts.inCart)) return 'low';
    if (ctx === 'card' && c.state === 'low' && c.policy === 'continue') return 'in';
    return tone(c.state);
  }

  // Everything paint() needs lives in attributes (R10), so set() from any driver and a server render agree.
  function read(el) {
    var pol = el.getAttribute('data-policy');
    var c = { state: el.getAttribute('data-state') || 'gone', n: num(el.getAttribute('data-n')), q: num(el.getAttribute('data-q')),
              policy: pol === 'continue' || pol === 'deny' ? pol : null, dead: el.hasAttribute('data-dead') };
    var opts = { notify: el.hasAttribute('data-notify'), unit: el.getAttribute('data-unit') || '', want: num(el.getAttribute('data-want')),
                 inCart: num(el.getAttribute('data-in-cart')), compact: el.hasAttribute('data-compact'), part: el.getAttribute('data-part') || '' };
    return { c: c, opts: opts, ctx: el.getAttribute('data-ctx') || 'pdp' };
  }
  function paint(el) {
    var r = read(el), t = label(r.c, r.ctx, r.opts), tn = toneOf(r.c, r.ctx, r.opts);
    var keep = String(el.className || '').split(/\s+/).filter(function (k) { return k && k !== 'so-stock' && k.indexOf('so-stock--') !== 0; });
    var next = keep.concat(['so-stock', 'so-stock--' + tn]).join(' ');
    // F2 M5: skip the write when nothing changed — avoids a needless style invalidation per card.
    if (el.className !== next) el.className = next;
    if (el.textContent !== t) el.textContent = t;
    el.hidden = !t;
  }
  function attr(el, name, val) { if (val == null || val === false || val === '') el.removeAttribute(name); else el.setAttribute(name, val === true ? '' : String(val)); }
  // opts: {notify?, unit?, want?, inCart?, cfg?}. A key that is absent leaves its attribute as it is
  // (data-unit from Liquid survives); a key present with a falsy value clears it.
  // All attributes are written first and the line is painted ONCE: el._soBatch tells the element's
  // attributeChangedCallback to skip its per-attribute repaint (the PDP line is aria-live).
  function set(el, v, opts) {
    if (!el) return;
    opts = opts || {};
    var c = classify(v, lowAt(opts.cfg));
    el._soBatch = true;
    try {
      attr(el, 'data-state', c.state);
      attr(el, 'data-n', c.n);
      attr(el, 'data-q', c.q);
      attr(el, 'data-policy', c.policy);
      attr(el, 'data-dead', c.dead);
      if ('notify' in opts) attr(el, 'data-notify', !!opts.notify);
      if ('unit' in opts) attr(el, 'data-unit', opts.unit);
      if ('want' in opts) attr(el, 'data-want', Number(opts.want) > 0 ? Number(opts.want) : null);
      if ('inCart' in opts) attr(el, 'data-in-cart', Number(opts.inCart) > 0 ? Number(opts.inCart) : null);
      if ('part' in opts) attr(el, 'data-part', opts.part || null);
    } finally { el._soBatch = false; }
    paint(el);
  }

  // Custom elements (browser only). Every connected element repaints at the next cut-off / midnight,
  // so a page left open past 7 AM stops saying "ships today".
  function _define(win) {
    if (!win.customElements || win.customElements.get('so-stock')) return;
    var live = new Set(), timer = null;
    function schedule() {
      var D = dates();
      if (timer || !live.size || !D) return;
      var cfg = cfgOf(); if (!cfg) return;
      var wait = Math.max(1000, D.nextBoundary(Date.now(), cfg) - Date.now() + 1000);
      timer = setTimeout(function () { timer = null; live.forEach(function (el) { el.repaint(); }); schedule(); }, Math.min(wait, 2147483000));
    }
    class SoStock extends HTMLElement {
      static get observedAttributes() {
        return ['data-state', 'data-n', 'data-q', 'data-policy', 'data-unit', 'data-ctx', 'data-notify', 'data-dead',
                'data-want', 'data-in-cart', 'data-compact', 'data-part'];
      }
      connectedCallback() { live.add(this); this.repaint(); schedule(); }
      disconnectedCallback() { live.delete(this); }
      attributeChangedCallback() { if (this.isConnected && !this._soBatch) this.repaint(); }
      repaint() { paint(this); }
    }
    class SoShip extends HTMLElement {
      static get observedAttributes() { return ['data-state', 'data-compact', 'data-bare']; }
      connectedCallback() { live.add(this); this.repaint(); schedule(); }
      disconnectedCallback() { live.delete(this); }
      attributeChangedCallback() { if (this.isConnected) this.repaint(); }
      repaint() {
        var t = shipText(this.getAttribute('data-state') || 'pre', null, null, this.hasAttribute('data-compact'), this.hasAttribute('data-bare'));
        if (t && this.textContent !== t) this.textContent = t;
      }
    }
    win.customElements.define('so-stock', SoStock);
    win.customElements.define('so-ship', SoShip);
  }

  return { classify: classify, shipText: shipText, label: label, tone: tone, toneOf: toneOf, overState: overState,
           maxAddable: maxAddable, lowAt: function () { return lowAt(); }, set: set, paint: paint, _define: _define };
});
